import React from 'react';
import { Container } from './styles';

export default function InputTaged({ children = null, currency = true, prefix = 'Kg' }) {
  return (
    <Container className="input-currency">
      {currency && <span className="currency">{prefix}</span>}
      {children}
    </Container>
  );
}
